<template>
    <div>
        <v-slide-y-transition>
            <v-app-bar v-if="!isSelectMode && selectedImages.length > 0" floating fixed color="cyan" style="width:50%; margin-left:25%;" height="64">
                <div class="d-flex flex-column align-center">
                    <v-btn class="ma-0" color="white" icon large @click.stop="onClickDelete">
                        <v-icon>mdi-delete-circle-outline</v-icon>
                    </v-btn>
                    <span class="caption white--text" style="margin-top:-10px">削除</span>
                </div>
            </v-app-bar>
        </v-slide-y-transition>
        <v-container fluid class="pa-0">
            <v-card class="ma-2 pa-1">
                <Title v-if="!isSelectMode" title="アルバム" />
                <v-card-text class="pa-0">
                    <v-container>
                        <v-row>
                            <v-text-field v-model="editItems.tag" dense outlined placeholder="タグでフィルタリング" append-icon="mdi-filter-variant" @click:append="onClickTagFilter" clearable />
                        </v-row>
                        <v-row dense align-content="center" justify="start">
                            <template v-for="image in images">
                                <v-col v-if="image.isDeleted == false && image.isFilterTarget" :key="image.imageID" align="center" cols="12" xs="12" sm="4" md="3" lg="3" xl="2">
                                    <v-card class="pa-0" :color="image.isSelected ? '#00aaffaa' : ''">
                                        <v-card-text class="pt-1">
                                            <!-- isSelectMode == false の時は、画像クリックでメニュー表示 -->
                                            <v-menu v-if="!isSelectMode" offset-y absolute close-on-content-click >
                                                <template v-slot:activator="{ on }">
                                                    <v-img
                                                        :src="image.body.image.url" 
                                                        aspect-ratio="1"
                                                        contain
                                                        v-on="on" >
                                                        <!-- <div v-if="image.isSelected" style="with:100%; height:100%; background-color:#00aaffaa" /> -->
                                                    </v-img>
                                                </template>
                                                <v-list dense>
                                                    <v-list-item @click="onClickImage(image)">
                                                        <v-list-item-icon><v-icon>mdi-image</v-icon></v-list-item-icon>
                                                        <v-list-item-content>プレビュー</v-list-item-content>
                                                    </v-list-item>
                                                    <v-list-item @click="onClickEditTag(image)">
                                                        <v-list-item-icon><v-icon>mdi-tag</v-icon></v-list-item-icon>
                                                        <v-list-item-content>タグ編集</v-list-item-content>
                                                    </v-list-item>
                                                </v-list>
                                            </v-menu>
                                            <!-- isSelectMode == true の時は、画像クリックでプレビュー -->
                                            <v-img
                                                v-else
                                                :src="image.body.image.url" 
                                                contain
                                                aspect-ratio="1"
                                                @click="onClickImage(image)">
                                                <!-- <div v-if="image.isSelected" style="with:100%; height:100%; background-color:#00aaffaa" /> -->
                                            </v-img>                                                        
                                        </v-card-text>
                                        <v-card-actions class="pa-0">
                                            <v-btn fab icon @click="onClickCheck(image)">
                                                <v-icon v-if="image.isSelected">mdi-check-circle-outline</v-icon>
                                                <v-icon v-if="!image.isSelected">mdi-checkbox-blank-circle-outline</v-icon>
                                            </v-btn>
                                            {{image.body.image.capturedDateTime}}
                                        </v-card-actions>
                                    </v-card>



                                    <!-- <table style="width:100%">
                                        <tr>
                                            <td align="center">
                                                <div style="position:relative">
                                                    <v-menu v-if="!isSelectMode" offset-y absolute close-on-content-click min-width="290" max-width="290">
                                                        <template v-slot:activator="{ on }">
                                                            <v-img
                                                                :src="image.body.image.url" 
                                                                max-width="200"
                                                                max-height="200"
                                                                aspect-ratio="1"
                                                                v-on="on" >
                                                                <div v-if="image.isSelected" style="with:100%; height:100%; background-color:#00aaffaa" />
                                                            </v-img>
                                                        </template>
                                                        <v-list dense>
                                                            <v-list-item @click="onClickImage(image)">
                                                                <v-list-item-icon><v-icon>mdi-image</v-icon></v-list-item-icon>
                                                                <v-list-item-content>プレビュー</v-list-item-content>
                                                            </v-list-item>
                                                            <v-list-item @click="onClickEditTag(image)">
                                                                <v-list-item-icon><v-icon>mdi-tag</v-icon></v-list-item-icon>
                                                                <v-list-item-content>タグ編集</v-list-item-content>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                    <v-img
                                                        v-else
                                                        :src="image.body.image.url" 
                                                        max-width="200"
                                                        max-height="200"
                                                        aspect-ratio="1"
                                                        @click="onClickImage(image)">
                                                        <div v-if="image.isSelected" style="with:100%; height:100%; background-color:#00aaffaa" />
                                                    </v-img>
                                                    <v-btn fab icon @click="onClickCheck(image)">
                                                        <v-icon v-if="image.isSelected">mdi-check-circle-outline</v-icon>
                                                        <v-icon v-if="!image.isSelected">mdi-checkbox-blank-circle-outline</v-icon>
                                                    </v-btn>
                                                    {{image.body.image.capturedDateTime}}
                                                </div>
                                            </td>
                                        </tr>
                                    </table> -->
                                </v-col>
                            </template>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="!isSelectMode" color="primary" @click="onClickCamera"><v-icon>mdi-camera</v-icon>撮影</v-btn>
                </v-card-actions>
            </v-card>
            <Capture v-if="enableCamera" v-model="enableCamera" @onCaptured="onCameraCaptured" />
            <ImageViewer ref="imageViewer" />
            <TagEditor ref="tagEditor" />
        </v-container>        
        <Confirm ref="confirm" />
    </div>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import fb from '@/firebase/firebase.js'
    import Capture from '@/components/tools/CaptureCamera';
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    import ImageCompresser from 'browser-image-compression'
    import ImageViewer from '@/components/tools/ImageViewer';
    import TagEditor from '@/components/camera/TagEditor';
    export default {
        components: {
            Title,
            TitleButton,
            Capture,
            Confirm,
            ImageViewer,
            TagEditor
        },
        props: {
            isSelectMode: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            selectedImages: function () {
                const list = []
                for (var i=0; i<this.images.length; i++){
                    if (this.images[i].isSelected && this.images[i].isDeleted == false && this.images[i].isFilterTarget) {
                        list.push(this.images[i])
                    }
                }
                return list
            }
        },
        data: function () {
            return {
                images: [],
                enableCamera: false,
                editItems: {
                    tag: ""
                }
            }
        },
        // watch: {
        //     "editItems.tag": function (value, old) {
        //         this.onClickTagFilter()
        //     }
        // },
        created: function () {
            const self = this
            const userUID = this.$store.getters["userUID"]
            this.images = []
            db.collection("users").doc(userUID).collection("uncategorized_images").get().then(function(snapShot){
                snapShot.forEach(function(doc){
                    self.images.push(
                        {
                            body:doc.data(),
                            isSelected: false,
                            isDeleted: false,
                            isFilterTarget: true,
                        }
                    )
                })
            }).catch (function(error) {
                self.mi_writeLog("Camera/created", "未分類データ取得失敗("+error+")")
            })
        },
        methods: {
            onClickCheck: function (image) {
                image.isSelected = !image.isSelected
                this.$emit("onSelectedImages", this.selectedImages)
            },
            onClickTagFilter: function () {
                if (this.editItems.tag == null) {
                    this.editItems.tag = ""
                }
                const tags = this.editItems.tag.split(" ")
                for (var i=0; i<this.images.length; i++) {
                    const image = this.images[i]
                    if (this.editItems.tag == null || this.editItems.tag == "") {
                        image.isFilterTarget = true
                    } else {
                        image.isFilterTarget = false
                        for (var j=0; j<image.body.tags.length; j++) {
                            if (tags.findIndex((v)=>v == image.body.tags[j]) >= 0){
                                image.isFilterTarget = true
                                break
                            }
                        }
                    }
                }
                this.$emit("onSelectedImages", this.selectedImages)
            },
            onClickCamera: function () {
                this.enableCamera = true
            },
            onClickImage: function (image) {
                console.log("onClickImage")
                this.$refs.imageViewer.show(
                    {
                        state: 1,
                        imageURL: image.body.image.url
                    }
                )
            },
            onClickEditTag: function (image) {
                this.$refs.tagEditor.show(image.body)
            },
            onClickDelete: function () {
                const self = this
                this.$refs.confirm.show({
                    title: "削除",
                    message: "選択されている写真を全て削除して宜しいですか？<br/>※削除すると元に戻す事は出来ません。",
                    width: 450,
                    icon: "mdi-alert",
                    buttonYes: "削除する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        self.delete()
                        return true
                    },
                })
            },
            onCameraCaptured: function (image) {
                const self = this

                // https://lab.syncer.jp/Web/JavaScript/Snippet/26/
                // バイナリに変換
                var byteString = atob( image.split( "," )[1] ) ;

                // "image/png"
                var mimeType = image.match( /(:)([a-z\/]+)(;)/ )[2] ;

                // バイナリからBlobを作成
                for( var i=0, l=byteString.length, content=new Uint8Array( l ); l>i; i++ ) {
                    content[i] = byteString.charCodeAt( i ) ;
                }

                var blob = new Blob( [ content ], {
                    type: mimeType ,
                } ) ;

                ImageCompresser(blob, {
                    maxSizeMB:1,
                    maxWidthOrHeight: 1280
                }).then(function(v){
                    // ================================
                    // 圧縮された画像をイベントで送信
                    var converter = new FileReader()
                    converter.onload = function (text) {
                        console.log(text, converter.result)
                        self.regist(converter.result)
                        // self.$emit("onImportedImage", converter.result)
                    }
                    converter.readAsDataURL(v)
                }).catch(function(error){
                    console.log("image compress error", error)
                })

                // this.$emit("onImportedImage", image)
            },
            delete: function () {

                this.$store.commit("processing", {start:true, message:"撮影画像を削除中です。"})

                try {
                    const self = this
                    const userUID = this.$store.getters["userUID"]

                    var imageDeleter = function () {
                        // ストレージから削除
                        for (var i=0; i<self.selectedImages.length; i++){
                            const image = self.selectedImages[i]
                            const uploadUrl = 
                                "images/users/" + userUID 
                                + "/uncategorized_images/" + image.body.imageID
                            var storage = fb.storage().ref()
                            var outputRef = storage.child(uploadUrl)
                            outputRef.delete().then(function (){
                                console.log("delete success("+image.body.imageID+")")
                            }).catch(function(error){
                                console.log("画像の削除失敗", error)
                            })
                        }
                        // 削除フラグをセットして終了
                        self.selectedImages.forEach(function(image){
                            image.isDeleted = true
                        })
                    }

                    var batch = db.batch()

                    for (var i=0; i<this.selectedImages.length; i++){
                        const image = this.selectedImages[i]
                        batch.delete(db.collection("users").doc(userUID).collection("uncategorized_images").doc(image.body.imageID))
                    }

                    batch.commit().then(function(){
                        self.$store.commit("notification", {message:"撮影画像を削除しました。"})
                        imageDeleter()
                    }).catch(function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"撮影画像の削除に失敗しました。", isError:true})
                    })
                } catch (error) {
                    console.log(error)
                    this.$store.commit("notification", {message:"撮影画像の削除に失敗しました。", isError:true})
                } finally {
                    this.$store.commit("processing", {start:false})
                }

            },
            regist: function (image) {

                this.$store.commit("processing", {start:true, message:"撮影画像を登録中です。"})

                try {
                    const self = this
                    const userUID = this.$store.getters["userUID"]
                    const currentDateTime = this.df_currentDateTime()
                    const filename = this.df_currentDateTime("yyyyMMddHHmmss")
                    const uploadUrl = 
                        "images/users/" + userUID 
                        + "/uncategorized_images/" + filename

                    var storage = fb.storage().ref()
                    var outputRef = storage.child(uploadUrl)

                    console.log("!!!!!", storage, outputRef)
                    
                    // ===============================
                    // 画像のアップロード
                    const startIndex = image.indexOf(",") + 1
                    outputRef.putString(image.substring(startIndex), 'base64').then(function(snapShot){
                        snapShot.ref.getDownloadURL().then (function(url){
                            console.log("imageUploader", "upload success - download url", url)
                            // ===============================
                            // 画像のアップロード成功で、DBに登録
                            const uncategorizedImage = {
                                version: "1.0.0",
                                imageID: filename,
                                image: {
                                    version: "1.0.0",
                                    url: url,
                                    capturedDateTime: currentDateTime
                                },
                                tags: [],
                                register: {
                                    userUID: userUID,
                                    dateTime: currentDateTime
                                }
                            }
                            console.log(uncategorizedImage)
                            db.collection("users").doc(userUID).collection("uncategorized_images").doc(filename).set(uncategorizedImage).then(function(){
                                self.$store.commit("notification", {message:"撮影画像を登録しました。"})
                                self.images.push(
                                    {
                                        body:uncategorizedImage,
                                        isSelected: false,
                                        isDeleted: false,
                                        isFilterTarget: true,
                                    }
                                )
                            }).catch(function(error){
                                console.log(error)
                                self.$store.commit("notification", {message:"撮影画像の登録に失敗しました。", isError:true})
                                self.mi_writeLog("Camera/regist", "exception("+error+")(1)")
                            })

                        }).catch(function(error){
                            console.log("画像のURL取得失敗", error)
                            self.$store.commit("notification", {message:"撮影画像の登録に失敗しました。", isError:true})
                            self.mi_writeLog("Camera/regist", "exception("+error+")(2)")
                        })
                    }).catch(function(error){
                        console.log("画像のアップロード失敗", error)
                        self.$store.commit("notification", {message:"撮影画像の登録に失敗しました。", isError:true})
                        self.mi_writeLog("Camera/regist", "exception("+error+")(3)")
                    })
                } catch (error) {
                    console.log(error)
                    this.$store.commit("notification", {message:"撮影画像の登録に失敗しました。", isError:true})
                    self.mi_writeLog("Camera/regist", "exception("+error+")(4)")
                } finally {
                    this.$store.commit("processing", {start:false})
                }
            }
        },
    }
</script>
